<template>
  <div>
    <div class="h370 rdiv">
      <div class="h295">
        <v-tree ref='tree' :data='data' :halfcheck='true' :multiple="true" :selectAlone="true" @node-check="getCheckedNodes" />
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Bus from '@/utils/bus'
  import 'vue-tree-halower/dist/halower-tree.min.css' // you can customize the style of the tree
  import { VTree, VSelectTree } from 'vue-tree-halower'
  import clonedeep from 'lodash.clonedeep'
  import utils from '@/utils'
  Vue.use(VTree)
  Vue.use(VSelectTree)
  export default {
    name: "treemenu",
    components: { VTree, VSelectTree },
    created () {
    },
    data () {
      return {
        selectedValues: [],
        options: []
      }
    },
    methods: {
      getCheckedNodes (nodes) {
        let ns = this.$refs.tree.getCheckedNodes(true)
        Bus.$emit('selected-menu', ns)
      }
    },
    props: ['data', 'selected']
  }
</script>

<style>
  .halo-tree .check { left: 0 !important; top: 0 !important; }
</style>



// WEBPACK FOOTER //
// src/page/byl/sys/role/treemenu2.vue